export default function resetOnSwitchClient() {
  localStorage.removeItem("selectedSite");
  document.location.href = "/";
}
